import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ValidacionMateriaPrima/filtrarValidacionMateriaPrima`, method: 'POST', body: values, token: token})
}